import _ from 'lodash';
import React, {useEffect, useState} from 'react';
import {useDebounce} from 'use-debounce';
import AgyleDictionaryField from '../../../components/ui/selector/agyleDictionaryField';
import API from '../../../app/api';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Avatar from '@mui/material/Avatar';
import PhoneIcon from '@mui/icons-material/Phone';
import {useTranslation} from 'react-i18next';
import moment from 'moment';
import {escapeRegExp} from '../../../pages/ward/forms/formsUtil';

const columnToSearch = ['_id', 'firstName', 'address.lines', 'address.postalCode'];

const ControlGP = (props) => {
    const {t} = useTranslation();

    // Options
    const [opt, setOpt] = useState([]);
    const [loading, setLoading] = useState(false);

    const [search, setSearch] = useState('');
    const [searchValueDebounced] = useDebounce(search, 250);
    const controller = new AbortController();

    useEffect(() => {
        return () => {
            controller.abort();
        };
    }, []);

    useEffect(() => {
        if (!_.isEmpty(searchValueDebounced) || props.surgery) {
            let filter = 'deactivated ne true';
            let paging = '';

            if (props.surgery) {
                filter += ` and surgery_id eq '${props.surgery?.__id}'`;
            } else {
                if (props.dontTrimSearch) {
                    filter = getFilter(searchValueDebounced, filter, escapeRegExp);
                } else {
                    for (let term of searchValueDebounced.split(" ")) {
                        filter = getFilter(term, filter, escapeRegExp);
                    }
                }

                paging = '&$pageSize=50&$page=1';
            }

            API.getDictByURL(`/gp?$filter=${encodeURIComponent(filter)}${paging}`, controller.signal)
                .then(dictData => {
                    if (dictData && dictData.__data && !_.isEmpty(dictData.__data)) {
                        let data = dictData.__data;
                        if (props.showLeftGp) {
                            setOpt(data);
                        } else {
                            setOpt(_.filter(data, d => !d?.leftParent || (d?.leftParent && moment(d?.leftParent).isAfter(moment()))));
                        }
                    } else {
                        setOpt([]);
                    }
                    setLoading(false);
                });
        }
        return () => {
        };
    }, [searchValueDebounced, props.surgery]);

    function getFilter(input, filter) {
        if (!_.isEmpty(input)) {
            if (!_.isEmpty(filter)) filter += ' AND ';
            for (let i = 0; i < columnToSearch?.length; i++) {
                if (i > 0) {
                    filter += ' or ';
                }
                filter += `${columnToSearch[i]} regex '.*` + escapeRegExp(input) + `.*'`;
            }
        }
        return filter;
    }

    const getVal = (value) => {
        if (value && value !== 'null') return value;
        return '';
    };

    const getSurgery = (surgery) => {
        if (surgery?.href) return surgery?.href?.replace('/surgeries/', '');
        return '';
    };

    const renderOptionLine = (props, option, test) => {
        return (
            <Box key={option?.__id} component="li" sx={{fontSize: 'small'}} {...props}>
                <Chip
                    avatar={<Avatar>{t('Id')}</Avatar>}
                    label={option?.__id} size="small" sx={{mr: 1}}
                />
                {option.surgery &&
                    <Chip
                        avatar={<Avatar>{t('Sur')}</Avatar>}
                        label={getSurgery(option?.surgery)} size="small" sx={{mr: 1}}
                    />
                }
                <b style={{fontSize: 'medium'}}>{getVal(option?.firstName)} {getVal(option?.title)}</b>
                <i style={{marginLeft: 5}}>
                    {option?.address?.postalCode ? `[${option?.address?.postalCode}] ` : ''}
                    {!_.isEmpty(option?.address) ? getAddress(option?.address) : ''}
                </i>
                {option?.phoneNumber &&
                    <div
                        style={{
                            marginLeft: 10,
                            display: 'flex',
                            flexWrap: 'nowrap',
                            flexDirection: 'row',
                            alignItems: 'center',
                        }}
                    >
                        <PhoneIcon/> {option?.phoneNumber}
                    </div>
                }
            </Box>
        );
    };

    const getAddress = (address) => {
        let text = '';
        if (address.lines && address.lines.length > 0) {
            address.lines.forEach(add => {
                text += add + ' ';
            });
        }
        return text;
    };

    const renderLabel = (option) => {
        return (
            `[${option?.__id}] [${getVal(option?.firstName)} ${getVal(option?.title)}] ` +
            `${option?.surgery ? `[${getSurgery(option?.surgery)}] ` : ''}` +
            `${option?.address?.postalCode ? `[${option?.address?.postalCode}] ` : ''}` +
            `${!_.isEmpty(option?.address) ? `[${getAddress(option?.address)}]` : ''} ` +
            `${option?.phoneNumber ? `[${option?.phoneNumber}] ` : ''} `
        );
    };

    const handleInputChange = (_e, val) => {
        setSearch(val);
    };

    const handleChange = (e, val) => {
        props.onChange(val, e);
    };

    return (
        <AgyleDictionaryField
            label={props.label}
            options={opt}
            onChange={handleChange}
            value={props.value}
            onInputChange={handleInputChange}
            getOptionLabel={renderLabel}
            renderLocalOption={renderOptionLine}
            isOptionEqualToValue={(opt, val) => opt.__id === val.__id}
            size={props.size || 'medium'}
            loading={loading}
            disabled={props.disabled}
            noBorder={props?.noBorder}
            error={props.error}
            placeholder={props.placeholder}
        />
    );
};

export default ControlGP;